// Foundation imports
import { AnalyticsHandler, default as AnalyticsHandlerModule } from '@Foundation/analyticsHandler';
import { clickoutside } from '@Foundation/directives/clickoutside/clickoutside';
import { nojshandler } from '@Foundation/directives/NoJsHandler/noJsHandler';
import { clickextension } from '@Foundation/directives/clickExtension/clickextension';
import { equalheight } from '@Foundation/directives/equalHeight/equalheight';
import { preventBodyScroll } from '@Foundation/directives/preventBodyScroll/preventBodyScroll';
import { ellipsis } from '@Foundation/directives/ellipsis/ellipsis';
import { srcset } from '@Foundation/directives/srcset/srcset';
import { sticky } from '@Foundation/directives/sticky/sticky';
import { setposition } from '@Foundation/directives/setposition/setposition';
import { footerspacement } from '@Foundation/directives/footerspacement/footerspacement';
import { recaptcha } from '@Foundation/directives/recaptcha/recaptcha';
import { debug } from '@Foundation/env/env';
import { InputHandler } from '@Foundation/inputHandler';
import LoadScriptModule from '@Foundation/loadscript';
import MqHandler from '@Foundation/mqHandler/MqHandler';
import { KeySiteCore } from '@Foundation/sitecore';
import { VueModule } from '@Foundation/utilities';
import '@Foundation/wsf/wsf';

// feature imports
import BackToTop from '@Feature/BackToTop';
import SkipTo from '@Feature/SkipTo';
import LoadMoreArticles from '@Feature/LoadMoreArticles';
import SocialCopy from '@Feature/SocialCopy';
import SocialShare from '@Feature/SocialShare';
import HeaderLink from '@Feature/HeaderLink';
import RenderlessFooter from '@Feature/Footer';
import MainHeader from '@Feature/MainHeader';
import CookieBanner from '@Feature/CookieBanner';
import ResponsiveImage from '@Feature/ResponsiveImage';
import Carousel from '@Feature/Carousel';
import NewsletterSignUp from '@Feature/NewsletterSignup';
import NewsletterSignUpFooter from '@Feature/NewsletterSignupFooter';
import NewsletterSignUpHeader from '@Feature/NewsletterSignupHeader';
import PrefillInputValue from '@Feature/PrefillInputValue';
import SelectOpenUrl from '@Feature/SelectOpenUrl';
import FormsEventTagging from '@Feature/FormsEventTagging';
import SearchBar from '@Feature/SearchBar';
import PageEventTagging from '@Feature/PageEventTagging';
import DebugInfo from '@Feature/DebugInfo';
import FilterDropdown from '@Feature/FilterDropdown';
import CustomSelect from '@Feature/CustomSelect';
import SearchPageFilters from '@Feature/SearchPageFilters';
import DynamicArticleGrid from '@Feature/DynamicArticleGrid';
import ChannelAdvisorCtaButton from '@Feature/ChannelAdvisor';

import ArticlePubExchange from '@Feature/ArticlePubExchange';

// project imports
import '@Themes/index.scss';
import Vue from 'vue';
import './registerServiceWorker';
import checkView from 'vue-check-view';

Vue.use(KeySiteCore);
Vue.use(checkView);

MqHandler.getMqHandler({
  small: 768,
  medium: 1024
});

AnalyticsHandler.getAnalyticsHandler(debug);
InputHandler.getInputHandler();

export default VueModule({
  asyncImports: [
    {
      module: () => import(/* webpackChunkName: "youtube-player" */ '@Feature/YoutubePlayer'),
      components: [
        'YoutubePlayer'
      ]
    },
    {
      module: () => import(/* webpackChunkName: "instagram" */ '@Feature/Instagram'),
      components: [
        'Instagram'
      ]
    },
    {
      module: () => import(/* webpackChunkName: "table-of-contents" */ '@Feature/TableOfContents'),
      components: [
        'TableOfContents',
      ],
    },
    {
      module: () => import(/* webpackChunkName: "instagram" */ '@Feature/Tiktok'),
      components: [
        'Tiktok'
      ]
    }
  ],
  imports: [
    AnalyticsHandlerModule,
    LoadScriptModule,

    // foundation components

    // feature components
    BackToTop,
    SkipTo,
    LoadMoreArticles,
    SocialCopy,
    SocialShare,
    HeaderLink,
    MainHeader,
    // MainMenu,
    CookieBanner,
    ResponsiveImage,
    Carousel,
    NewsletterSignUp,
    NewsletterSignUpFooter,
    NewsletterSignUpHeader,
    PrefillInputValue,
    SelectOpenUrl,
    FormsEventTagging,
    SearchBar,
    PageEventTagging,
    DebugInfo,
    RenderlessFooter,
    FilterDropdown,
    CustomSelect,
    SearchPageFilters,
    DynamicArticleGrid,
    ChannelAdvisorCtaButton,  
    ArticlePubExchange
  ],
  directives: {
    clickoutside,
    clickextension,
    equalheight,
    srcset,
    ellipsis,
    sticky,
    setposition,
    preventBodyScroll,
    footerspacement,
    nojshandler,
    recaptcha
  },
  components: {},
  filters: {}
});
